import ActionTypes from "../inc/ActionsTypes";

const defaultState = {
    sources:[]
}
const AllSourceReducer = (state = defaultState, actions) =>{
    if(actions.type === ActionTypes.SET_ALL_SOURCE){
        state = {
            ...state,
            sources:actions.payload
        }
    }
    return state;
}
export default AllSourceReducer;